import {
  LOADING,
  RESULT,
  LIST,
  LINK_MERCHANT_ID,
  UNBIND_MERCHANT_ID
} from "./actionTypes"

export const loading = actionType => ({
  type: LOADING,
  payload: { actionType },
})

export const result = (actionType, result) => ({
  type: RESULT,
  payload: { actionType, result },
})

export const list = () => ({
  type: LIST,
})
export const link_merchant_id = payload => ({
  type: LINK_MERCHANT_ID,
  payload
})
export const unbind_merchat_id = payload => ({
  type: UNBIND_MERCHANT_ID,
  payload
})
